<template>
    <div class="login_screen">
        <div class="login_image">
            <img src="../../assets/login-image.jpg" alt="">
            <a :href="LINK_BANNER" target="_blank"></a>
        </div>

        <div class="logo">
            <img src="../../assets/logo.png" alt="">
        </div>

        <div class="login_form">
            <div class="mb-1">
                <input class="p-15" v-validate="'required|email'" name="form_email" type="email" v-model="formData.email" placeholder="メールアドレス">
                <div class="vee-validate-message">{{ errors.first('form_email') }}</div>
            </div>

            <div class="mb-1">
                <input class="p-15" v-validate="'required|min:6'" name="password" type="password" v-model="formData.password" placeholder="パスワード">
                <div class="vee-validate-message">{{ errors.first('password') }}</div>
            </div>

            <p class="forgot_password_link">
                <router-link :to="{name: 'forgot-password'}">パスワードを忘れた場合</router-link>
            </p>
            <a href="javascript:void(0)" @click="login" class="button deep_blue block">ログイン</a>
        </div>
        <p class="term-of-use-link text-center">
              <router-link :to="{name: 'term-of-use'}">利用契約</router-link>
        </p>
    </div>
</template>

<script>
  import {LINK_BANNER} from '../../config/const'
  import {mapActions} from 'vuex'
  import { CAN_SHOW_SURVEY } from '@/config'

  export default {
    name: 'login',
    data () {
      return {
        formData: {email: '', password: '', type: 'sns'},
        LINK_BANNER
      }
    },
    computed: {
      canShowSurvey () {
        return CAN_SHOW_SURVEY.indexOf(this.$auth.user().authority) !== -1
      }
    },
    methods: {
      ...mapActions({
        getNotifications: 'masterData/getNotifications',
        setIsShowSurveyToLocalStorage: 'surveys/setIsShowSurveyToLocalStorage'
      }),
      login () {
        this.$validator.validateAll().then(async res => {
          if (res) {
            const loading = this.$loading.show({opacity: 1})
            this.$auth.login({
              data: this.formData,
              fetchUser: false,
              redirect: false,
              rememberMe: true,
              success: async (response) => {
                await this.$auth.token(null, response.data.token)
                await this.$auth.fetch()
                if (this.$auth.user().is_maker && this.canShowSurvey) await this.setIsShowSurveyToLocalStorage()
                this.$router.push('/')
                loading.hide()
              },
              error: (e) => {
                loading.hide()
                const code = e.response.status
                if (code === 403) {
                  this.$message({message: 'あなたのSNS権限では本機能を利用できません', type: 'error'})
                } else if (code === 401) {
                  const message = `パスワードの有効期限が切れています。「パスワードを忘れた場合」 のリンクから、パスワードの再設定を行ってください。`
                  this.$message({message, type: 'success'})
                  this.$router.push({ name: 'forgot-password' })
                } else if (code === 402) {
                  this.$message({message: 'パスワードの有効期限が切れています。パスワードの再設定を行ってください。', type: 'error'})
                  this.$router.push({ path: `/reset-password/${e.response.data.token}` })
                } else {
                  this.$message({message: '入力されたユーザーは存在しません!', type: 'error'})
                }
              }
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/screens/auth/login.vue